import { NUMBER_SIZE } from '../../../constants/size'
import { ICON_CHEVRON_DIRECTION } from '../../Icon'

export const NAV_ARROWS_SIZE = NUMBER_SIZE.size40

export const NAV_ARROWS_NEXT_BUTTON_DIRECTION = ICON_CHEVRON_DIRECTION.RIGHT

export const NAV_ARROWS_PREV_BUTTON_DIRECTION = ICON_CHEVRON_DIRECTION.LEFT

export const NAV_ARROWS_MIN_VALUE = 1
